module.exports = {"141034100":"永安镇","141034101":"对竹镇","141034102":"勍香镇","141034103":"和平镇","141034104":"僧念镇","141034200":"佃坪乡","141034201":"团柏乡","141034202":"邢家要乡","141034400":"社区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141034.json
// module id = 333
// module chunks = 0